// Sección 6 del mock: cambios recientes de parámetros, más reciente primero, con antes/después.
import { cn } from '@/lib/cn';
import type { AuditRow } from './recentChanges';
import { CATEGORY_CHIP_CLASS } from './types';

const HEADERS = ['Fecha', 'Hora', 'Autor', 'Categoría', 'Parámetro', 'Antes', 'Después', 'Motivo'];
const CELL = 'border-b border-border/40 px-2 py-1';
const NOTE = 'px-3 py-3 text-[11px]';
const UNKNOWN_CATEGORY_CHIP = 'bg-muted text-foreground';

export function AuditTable({
    rows,
    loading,
    failed,
}: {
    rows: readonly AuditRow[];
    loading: boolean;
    failed: boolean;
}) {
    if (failed) {
        return (
            <p role="alert" className={cn(NOTE, 'text-destructive')}>
                No se pudo cargar la auditoría. Recarga la página para intentarlo de nuevo.
            </p>
        );
    }
    if (loading) return <p className={cn(NOTE, 'text-muted-foreground')}>Cargando auditoría…</p>;
    if (rows.length === 0) {
        return (
            <p className={cn(NOTE, 'text-muted-foreground')}>
                Sin cambios registrados en los últimos 30 días.
            </p>
        );
    }

    return (
        <div className="overflow-x-auto">
            <table className="w-full border-collapse text-[10.5px]">
                <thead>
                    <tr>
                        {HEADERS.map((h) => (
                            <th
                                key={h}
                                className="bg-muted/40 px-2 py-1 text-left text-[9px] font-bold uppercase tracking-wide text-muted-foreground"
                            >
                                {h}
                            </th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {rows.map((row, index) => (
                        <tr key={`${row.technicalKey}-${row.date}-${row.time}-${String(index)}`}>
                            <td className={cn(CELL, 'tabular-nums')}>{row.date}</td>
                            <td className={cn(CELL, 'tabular-nums')}>{row.time}</td>
                            <td className={CELL}>{row.author}</td>
                            <td className={CELL}>
                                <span
                                    className={cn(
                                        'inline-flex items-center rounded-[3px] px-1.5 py-px text-[9px] font-bold uppercase tracking-wide',
                                        row.category
                                            ? CATEGORY_CHIP_CLASS[row.category]
                                            : UNKNOWN_CATEGORY_CHIP,
                                    )}
                                >
                                    {row.categoryLabel}
                                </span>
                            </td>
                            <td className={CELL}>
                                {row.name}
                                <div className="font-mono text-[9.5px] text-muted-foreground">
                                    {row.technicalKey}
                                </div>
                            </td>
                            <td
                                className={cn(
                                    CELL,
                                    'tabular-nums text-muted-foreground line-through',
                                )}
                            >
                                {row.before}
                            </td>
                            <td className={cn(CELL, 'font-bold tabular-nums text-success')}>
                                {row.after}
                            </td>
                            <td className={cn(CELL, 'text-muted-foreground')}>{row.reason}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
}
